<template>
    <div class="row">
        <div class="col-md-12">
            <div class="field field-name-body field-type-text-with-summary field-label-hidden">
                <div class="field-items">
                    <div class="field-item even">
                        <p v-html="$t('Bareme.etape1.infoBareme', {url: 'https://www.ge.ch/bareme-c-impot-source/bareme-c-perception-ajuste'})"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'section-info-bareme-ajuste',
};
</script>

<style scoped>

</style>
